import lenis from './lenis'
import { isActivationKey } from '../utils/dom'

let modalController = null

function makeInteractive(element) {
	if (!element) return

	const interactiveSelector = 'a[href], button, input, select, textarea'

	if (element.matches(interactiveSelector)) return

	element.setAttribute('role', 'button')
	element.tabIndex = 0

	if (element.hasAttribute('data-modal-close') && !element.hasAttribute('aria-label')) {
		element.setAttribute('aria-label', 'Close modal')
	}
}

export default function initModal() {
	modalController?.abort()
	modalController = new AbortController()
	const { signal } = modalController

	const modalGroup = document.querySelector('[data-modal-group-status]')
	const modals = Array.from(document.querySelectorAll('[data-modal-name]'))
	const modalTargets = Array.from(document.querySelectorAll('[data-modal-target]')).filter((target) => target.getAttribute('data-modal-target'))
	let lastFocusedElement = null

	if (!modalTargets.length && !modals.length) {
		document.body.classList.remove('modal--is-active')
		lenis.start()
		return
	}

	// Function to close all modals
	function closeAllModals({ restoreFocus = true } = {}) {
		modalTargets.forEach((target) =>
			target.setAttribute('data-modal-status', 'not-active'),
		)
		modals.forEach((modal) => {
			modal.setAttribute('data-modal-status', 'not-active')
			modal.setAttribute('aria-hidden', 'true')
		})
		document.body.classList.remove('modal--is-active')
		lenis.start()

		if (modalGroup) {
			modalGroup.setAttribute('data-modal-group-status', 'not-active')
		}

		if (restoreFocus) {
			lastFocusedElement?.focus({ preventScroll: true })
		}
	}

	function openModal(modalTarget) {
		const modalTargetName = modalTarget.getAttribute('data-modal-target')
		const targetModal = document.querySelector(`[data-modal-name="${modalTargetName}"]`)

		if (!targetModal) return

		lastFocusedElement = modalTarget

		// Close all modals
		closeAllModals({ restoreFocus: false })

		// Activate clicked modal
		modalTarget.setAttribute('data-modal-status', 'active')
		targetModal.setAttribute('data-modal-status', 'active')
		targetModal.setAttribute('aria-hidden', 'false')
		targetModal.setAttribute('tabindex', '-1')
		document.body.classList.add('modal--is-active')
		lenis.stop()

		// Set group to active
		if (modalGroup) {
			modalGroup.setAttribute('data-modal-group-status', 'active')
		}

		targetModal.focus({ preventScroll: true })
	}

	modals.forEach((modal) => {
		modal.setAttribute('aria-hidden', modal.getAttribute('data-modal-status') === 'active' ? 'false' : 'true')
	})

	// Open modal
	modalTargets.forEach((modalTarget) => {
		makeInteractive(modalTarget)

		modalTarget.addEventListener('click', function () {
			openModal(this)
		}, { signal })

		modalTarget.addEventListener('keydown', function (event) {
			if (isActivationKey(event)) {
				event.preventDefault()
				openModal(this)
			}
		}, { signal })
	})

	// Close modal
	document.querySelectorAll('[data-modal-close]').forEach((closeBtn) => {
		makeInteractive(closeBtn)

		closeBtn.addEventListener('click', () => closeAllModals(), { signal })
		closeBtn.addEventListener('keydown', (event) => {
			if (isActivationKey(event)) {
				event.preventDefault()
				closeAllModals()
			}
		}, { signal })
	})

	// Close modal on `Escape` key
	document.addEventListener('keydown', function (event) {
		if (event.key === 'Escape') {
			closeAllModals()
		}
	}, { signal })
}
